export default __webpack_public_path__ + "js/components/liveClassPurchasePage/Pages/PlanPage/money-back-92e76282bc01f145eda8f0034a30f4b7.svg";